<template>
    <div class="min-h-screen bg-black text-white py-8 px-4 sm:px-6 lg:px-8">
        <div class="container mx-auto">
            <!-- Titre principal -->
            <div class="flex justify-center items-center  space-x-4">
                <h1 class="text-3xl font-bold text-center text-[#950C16] mb-8">{{ $t('listedesreservations') }}</h1>
                <router-link v-if="type == 2" to="/test"
                    class="text-3xl font-bold text-center text-[#950C16] mb-8">scanner</router-link>
                    <button @click="searchModal = true" v-if="type == 2" 
                    class="text-3xl font-bold text-center text-[#950C16] mb-8">rechercher</button>
                <button @click="logout" class="text-3xl font-bold text-center text-[#950C16] mb-8">logout</button>
            </div>

            <!-- Table des réservations -->
            <div class="overflow-x-auto bg-[#1A1A1A] rounded-lg shadow-lg">
                <table class="min-w-full table-auto border-collapse border border-gray-700">
                    <thead>
                        <tr class="bg-[#950C16] text-white">
                            <th class="px-4 py-2 text-left text-sm font-medium">{{ $t('table') }}</th>
                            <th class="px-4 py-2 text-left text-sm font-medium"> {{ $t('type') }}</th>
                            <th class="px-4 py-2 text-left text-sm font-medium">{{ $t('nombre de plac(s)') }}</th>
                            <th class="px-4 py-2 text-left text-sm font-medium">{{ $t('date') }}</th>
                            <th class="px-4 py-2 text-left text-sm font-medium">{{ $t(('actions')) }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="reservation in reservations" :key="reservation.id"
                            class="border-b border-gray-700 hover:bg-gray-800 transition">
                            <td class="px-4 py-2 text-sm">{{ reservation.table.titre }}</td>
                            <td class="px-4 py-2 text-sm">{{ reservation.ticket.type }}</td>
                            <td class="px-4 py-2 text-sm">{{ reservation.place }}</td>
                            <td class="px-4 py-2 text-sm">{{ $moment(reservation.created_at).format('DD/MM/YYYY HH:mm')
                            }}</td>
                            <td class="px-4 py-2 text-sm">
                                <button @click="voirDetails(reservation)"
                                    class="px-3 py-1 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded transition">
                                    {{ $t('voir') }}
                                </button>
                                <!-- <button @click="annulerReservation(reservation.id)"
                                    class="ml-2 px-3 py-1 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded transition">
                                    Annuler
                                </button> -->
                            </td>
                        </tr>
                        <tr v-if="reservations.length === 0">
                            <td colspan="5" class="px-4 py-4 text-center text-gray-400">{{ $t('aucunereservationtrouve')
                            }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Modal -->
        <div v-if="selectedReservation"
            class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
            <div class="bg-[#1A1A1A] rounded-lg shadow-lg max-w-lg w-full p-8">
                <h2 class="text-2xl font-bold text-white mb-4">Détails de la Réservation</h2>
                <p class="text-sm text-gray-400"><strong>Table :</strong> {{ selectedReservation.table.titre }}</p>
                <p class="text-sm text-gray-400"><strong>Type :</strong> {{ selectedReservation.ticket.type }}</p>
                <p class="text-sm text-gray-400"><strong>Place :</strong> {{ selectedReservation.place }}</p>
                <p class="text-sm text-gray-400"><strong>Date :</strong> {{
                    $moment(selectedReservation.created_at).format('DD/MM/YYYY HH:mm') }}</p>
                <p class="text-sm text-gray-400"><strong>Prix du ticket :</strong> {{ selectedReservation.ticket.price
                }}€</p>
                <p class="text-sm text-gray-400"><strong>Boissons :</strong>
                    <span v-if="selectedReservation.boissons.length > 0">
                        {{selectedReservation.boissons.map(b => b.nom).join(', ')}}
                    </span>
                    <span v-else>Pas de boissons commandées</span>
                </p>

                <!-- Boutons -->
                <div class="flex justify-end mt-4">
                    <button @click="selectedReservation = null"
                        class="px-4 py-2 text-sm font-medium bg-gray-600 hover:bg-gray-700 text-white rounded transition">
                        Fermer
                    </button>
                </div>
            </div>
        </div>

        <div class="" v-if="searchModal">
            <reservation-search-modal @closeSearchModal="searchModal= false"/>
        </div>
    </div>
</template>

<script>
import ReservationSearchModal from './ReservationSearchModal.vue';

export default {
    components:{
        ReservationSearchModal
    },
    data() {
        return {
            reservations: [],
            selectedReservation: null,
            type: 0,
            modal:false,
            searchModal:false
        };
    },
    created() {
        this.type = localStorage.getItem('type')
        if (!localStorage.getItem('jwtToken')) return this.$router.push("/");
        this.axios.get(`${this.$store.state.api}/getReservations`, { headers: { Authorization: `Bearer ${localStorage.getItem('jwtToken')}` } })
            .then(({ data }) => this.reservations = data)
            .catch(e => e.response?.status === 401 && (localStorage.clear(), this.$router.push("/")));
    },
    methods: {
        logout() {
            localStorage.clear();
            this.type = 0
            this.reservations = []
            this.$router.push("/")
        },
        voirDetails(reservation) {
            this.selectedReservation = reservation;
        },
        annulerReservation(id) {
            const confirmation = confirm("Êtes-vous sûr de vouloir annuler cette réservation ?");
            if (confirmation) {
                // Suppression locale pour simuler une annulation
                this.reservations = this.reservations.filter(reservation => reservation.id !== id);

                // Appel API pour annuler
                this.axios.delete(`${this.$store.state.api}/reservations/${id}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
                    },
                }).then(() => console.log(`Réservation ${id} annulée`))
                    .catch((error) => console.error(error));
            }
        },
    },
};
</script>

<style scoped>
/* Ajout de transitions */
button {
    transition: all 0.3s ease-in-out;
}

/* Animation pour le modal */
.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.3s ease;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;
}
</style>
